var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigcontact3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 251,
    viewBox: "0 0 250 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_6490)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.625,
    width: 250,
    height: 250,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 17.9658,
    y1: 120.093,
    x2: 17.9658,
    y2: -21.4222,
    stroke: "url(#paint0_linear_75_6490)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.9658,
    y1: 120.093,
    x2: 52.9658,
    y2: -21.4222,
    stroke: "url(#paint1_linear_75_6490)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.9658,
    y1: 120.093,
    x2: 88.9658,
    y2: -21.4222,
    stroke: "url(#paint2_linear_75_6490)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.966,
    y1: 120.093,
    x2: 124.966,
    y2: -21.4222,
    stroke: "url(#paint3_linear_75_6490)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.966,
    y1: 120.093,
    x2: 160.966,
    y2: -21.4222,
    stroke: "url(#paint4_linear_75_6490)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.966,
    y1: 120.093,
    x2: 195.966,
    y2: -21.4222,
    stroke: "url(#paint5_linear_75_6490)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.966,
    y1: 120.093,
    x2: 231.966,
    y2: -21.4222,
    stroke: "url(#paint6_linear_75_6490)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 18.954,
    x2: 258.387,
    y2: 18.954,
    stroke: "url(#paint7_linear_75_6490)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 77.954,
    x2: 258.387,
    y2: 77.954,
    stroke: "url(#paint8_linear_75_6490)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 47.954,
    x2: 258.387,
    y2: 47.954,
    stroke: "url(#paint9_linear_75_6490)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 17.125,
    width: 87,
    height: 87,
    rx: 43.5,
    fill: "url(#paint10_linear_75_6490)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4004 48.6253C41.4004 47.4414 42.3604 46.4825 43.5432 46.4825H63.2569C64.4397 46.4825 65.3997 47.4425 65.3997 48.6253V59.7679C65.3997 60.9518 64.4397 61.9107 63.2569 61.9107H43.5432C43.2618 61.9107 42.9831 61.8552 42.7232 61.7475C42.4632 61.6399 42.227 61.482 42.028 61.283C41.829 61.0841 41.6712 60.8478 41.5635 60.5879C41.4558 60.3279 41.4004 60.0493 41.4004 59.7679V48.6253ZM49.1144 54.1966C49.1144 53.06 49.566 51.9699 50.3697 51.1662C51.1734 50.3625 52.2634 49.911 53.4 49.911C54.5366 49.911 55.6267 50.3625 56.4304 51.1662C57.2341 51.9699 57.6856 53.06 57.6856 54.1966C57.6856 55.3332 57.2341 56.4233 56.4304 57.227C55.6267 58.0307 54.5366 58.4822 53.4 58.4822C52.2634 58.4822 51.1734 58.0307 50.3697 57.227C49.566 56.4233 49.1144 55.3332 49.1144 54.1966ZM61.1141 53.3395C60.8868 53.3395 60.6687 53.4298 60.508 53.5905C60.3473 53.7513 60.257 53.9693 60.257 54.1966V54.2057C60.257 54.6789 60.641 55.0629 61.1141 55.0629H61.1232C61.3505 55.0629 61.5686 54.9726 61.7293 54.8118C61.89 54.6511 61.9803 54.4331 61.9803 54.2057V54.1966C61.9803 53.9693 61.89 53.7513 61.7293 53.5905C61.5686 53.4298 61.3505 53.3395 61.1232 53.3395H61.1141ZM44.8289 54.1966C44.8289 53.9693 44.9192 53.7513 45.0799 53.5905C45.2406 53.4298 45.4587 53.3395 45.686 53.3395H45.6951C45.9224 53.3395 46.1405 53.4298 46.3012 53.5905C46.4619 53.7513 46.5522 53.9693 46.5522 54.1966V54.2057C46.5522 54.4331 46.4619 54.6511 46.3012 54.8118C46.1405 54.9726 45.9224 55.0629 45.6951 55.0629H45.686C45.4587 55.0629 45.2406 54.9726 45.0799 54.8118C44.9192 54.6511 44.8289 54.4331 44.8289 54.2057V54.1966Z",
    fill: "#4583FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4 51.6462C52.7236 51.6462 52.0749 51.9149 51.5966 52.3932C51.1183 52.8715 50.8496 53.5202 50.8496 54.1966C50.8496 54.873 51.1183 55.5217 51.5966 56C52.0749 56.4783 52.7236 56.747 53.4 56.747C54.0764 56.747 54.7251 56.4783 55.2034 56C55.6817 55.5217 55.9504 54.873 55.9504 54.1966C55.9504 53.5202 55.6817 52.8715 55.2034 52.3932C54.7251 51.9149 54.0764 51.6462 53.4 51.6462Z",
    fill: "#4583FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.792 63.0485V66.767C58.792 69.0402 59.695 71.2203 61.3024 72.8277C62.9098 74.4351 65.0899 75.3381 67.3632 75.3381H69.666C71.4842 75.3381 73.228 74.6158 74.5138 73.3302L76.4977 71.3463C77.7175 70.1261 78.4324 68.4909 78.5 66.767H78.5057V63.3317C78.506 63.1638 78.5394 62.9977 78.6039 62.8428C78.6684 62.6879 78.7628 62.5472 78.8817 62.4288C79.1128 62.1857 79.2398 61.8619 79.2356 61.5265C79.2313 61.1911 79.0961 60.8706 78.8588 60.6335C78.6215 60.3963 78.301 60.2613 77.9656 60.2573C77.6301 60.2532 77.3064 60.3804 77.0634 60.6117C76.3442 61.33 75.9383 62.3037 75.9343 63.3202V65.9099C75.9343 66.1372 75.844 66.3552 75.6833 66.5159C75.5226 66.6767 75.3045 66.767 75.0772 66.767C73.4913 66.7645 71.9264 67.1303 70.5059 67.8355C70.8724 67.1265 71.3988 66.5124 72.0434 66.0418C72.688 65.5711 73.4332 65.2568 74.2201 65.1236V52.6245C74.2201 52.2836 74.0846 51.9565 73.8435 51.7154C73.6024 51.4743 73.2754 51.3389 72.9344 51.3389C72.5934 51.3389 72.2664 51.4743 72.0253 51.7154C71.7842 51.9565 71.6487 52.2836 71.6487 52.6245V61.0563C71.1002 60.7397 70.5254 60.4883 69.9345 60.3032V50.9103C69.9345 50.5693 69.7991 50.2423 69.5579 50.0012C69.3168 49.7601 68.9898 49.6246 68.6488 49.6246C68.3079 49.6246 67.9808 49.7601 67.7397 50.0012C67.4986 50.2423 67.3632 50.5693 67.3632 50.9103V59.91C67.0931 59.91 66.8232 59.9229 66.5543 59.9484V60.5988C66.5543 61.9523 65.4893 63.0485 64.1771 63.0485H58.792Z",
    fill: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 17.125,
    width: 87,
    height: 87,
    rx: 43.5,
    stroke: "url(#paint11_linear_75_6490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3934 212.848C28.6348 212.848 31.5591 210.616 31.5591 207.022V206.732H28.9027V207.022C28.9027 209.321 27.4517 210.527 24.4158 210.527C20.911 210.527 19.2145 208.875 19.2145 205.147C19.2145 201.419 20.911 199.745 24.4158 199.745C27.4517 199.745 28.9027 200.972 28.9027 203.249V203.562H31.5591V203.249C31.5591 199.678 28.6125 197.445 24.3934 197.445C19.7503 197.445 16.6697 200.481 16.6697 205.147C16.6697 209.812 19.7503 212.848 24.3934 212.848ZM36.5943 212.848C39.1168 212.848 40.8803 211.732 41.4607 209.857H41.617V212.625H43.8269V205.883C43.8269 203.227 42.242 201.307 38.715 201.307C35.188 201.307 33.0896 203.205 33.0896 205.727V205.817H35.4782V205.727C35.4782 204.098 36.4827 203.428 38.5364 203.428C40.6571 203.428 41.4607 204.075 41.4607 205.906V206.553L36.4157 207.089C34.2281 207.334 32.8441 208.227 32.8441 209.946C32.8441 211.777 34.295 212.848 36.5943 212.848ZM35.2549 209.79C35.2549 208.919 35.8577 208.629 37.1077 208.473L41.4607 207.982C41.4607 210.169 39.7642 211.107 37.2417 211.107C35.8577 211.107 35.2549 210.683 35.2549 209.79ZM51.2249 212.848C54.3501 212.848 56.4038 211.62 56.4038 209.544C56.4038 207.714 55.1984 206.821 52.5643 206.486L49.9971 206.129C48.3229 205.906 47.8765 205.593 47.8765 204.723C47.8765 203.673 48.5908 203.227 50.6222 203.227C53.0777 203.227 53.7474 203.919 53.7474 205.236V205.37H56.136V205.303C56.136 202.669 54.0822 201.307 50.6892 201.307C47.2737 201.307 45.5102 202.691 45.5102 204.633C45.5102 206.486 46.7826 207.379 48.881 207.647L51.9169 208.049C53.5019 208.272 54.0376 208.562 54.0376 209.477C54.0376 210.46 53.3902 210.906 51.2249 210.906C48.9033 210.906 48.0327 210.437 48.0327 208.986V208.808H45.6219V208.875C45.6219 211.442 47.6532 212.848 51.2249 212.848ZM60.5542 212.625V207.245C60.5542 204.901 61.4917 203.473 64.1258 203.473C66.4251 203.473 67.4296 204.366 67.4296 206.598V212.625H69.8182V206.017C69.8182 203.316 68.3225 201.307 65.2643 201.307C62.4293 201.307 61.0676 203.048 60.6881 204.924H60.5542V197.669H58.1433V212.625H60.5542ZM81.1139 212.625L83.5695 206.241L84.4177 203.517H84.5963L85.4446 206.241L87.8778 212.625H90.8691L94.2398 201.53H91.7843L89.9315 207.826L89.4181 210.683H89.2395L88.4135 207.602L86.0696 201.53H82.9891L80.6675 207.602L79.8415 210.683H79.6629L79.1495 207.826L77.2967 201.53H74.7965L78.1227 212.625H81.1139ZM97.8753 200.236V197.669H95.4645V200.236H97.8753ZM97.8753 212.625V201.53H95.4645V212.625H97.8753ZM107.385 212.625V210.46H105.376C103.992 210.46 103.367 210.103 103.367 208.741V203.54H107.385V201.53H103.367V199.097H100.978V201.53H99.1033V203.54H100.978V208.875C100.978 211.576 102.452 212.625 104.84 212.625H107.385ZM111.304 212.625V207.245C111.304 204.901 112.242 203.473 114.876 203.473C117.175 203.473 118.179 204.366 118.179 206.598V212.625H120.568V206.017C120.568 203.316 119.072 201.307 116.014 201.307C113.179 201.307 111.817 203.048 111.438 204.924H111.304V197.669H108.893V212.625H111.304ZM127.625 212.848C130.125 212.848 131.754 211.643 132.223 209.433H132.379V212.625H134.589V197.669H132.179V204.544H132.045C131.598 202.669 130.103 201.307 127.468 201.307C124.098 201.307 122.178 203.629 122.178 207.089C122.178 210.504 124.12 212.848 127.625 212.848ZM124.611 207.089C124.611 204.41 125.995 203.495 128.317 203.495C130.795 203.495 132.179 204.656 132.179 207.022V207.201C132.179 209.522 130.728 210.638 128.361 210.638C125.973 210.638 124.611 209.745 124.611 207.089ZM139.229 212.625V206.397C139.229 204.41 140.011 203.361 141.908 203.361C143.56 203.361 144.23 204.098 144.23 205.683V206.665H146.618V205.214C146.618 203.115 145.525 201.307 143.002 201.307C140.725 201.307 139.52 202.736 139.185 204.522H139.029V201.53H136.819V212.625H139.229ZM151.392 212.848C153.914 212.848 155.678 211.732 156.258 209.857H156.414V212.625H158.624V205.883C158.624 203.227 157.04 201.307 153.512 201.307C149.985 201.307 147.887 203.205 147.887 205.727V205.817H150.276V205.727C150.276 204.098 151.28 203.428 153.334 203.428C155.455 203.428 156.258 204.075 156.258 205.906V206.553L151.213 207.089C149.026 207.334 147.642 208.227 147.642 209.946C147.642 211.777 149.093 212.848 151.392 212.848ZM150.052 209.79C150.052 208.919 150.655 208.629 151.905 208.473L156.258 207.982C156.258 210.169 154.562 211.107 152.039 211.107C150.655 211.107 150.052 210.683 150.052 209.79ZM166.089 212.625L168.545 206.241L169.393 203.517H169.572L170.42 206.241L172.853 212.625H175.845L179.215 201.53H176.76L174.907 207.826L174.394 210.683H174.215L173.389 207.602L171.045 201.53H167.965L165.643 207.602L164.817 210.683H164.638L164.125 207.826L162.272 201.53H159.772L163.098 212.625H166.089ZM183.699 212.848C186.222 212.848 187.985 211.732 188.565 209.857H188.722V212.625H190.932V205.883C190.932 203.227 189.347 201.307 185.82 201.307C182.293 201.307 180.194 203.205 180.194 205.727V205.817H182.583V205.727C182.583 204.098 183.587 203.428 185.641 203.428C187.762 203.428 188.565 204.075 188.565 205.906V206.553L183.52 207.089C181.333 207.334 179.949 208.227 179.949 209.946C179.949 211.777 181.4 212.848 183.699 212.848ZM182.36 209.79C182.36 208.919 182.962 208.629 184.212 208.473L188.565 207.982C188.565 210.169 186.869 211.107 184.346 211.107C182.962 211.107 182.36 210.683 182.36 209.79ZM195.495 212.625V197.669H193.084V212.625H195.495Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_6490",
    x1: 18.4658,
    y1: -1.34432,
    x2: 18.4659,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_75_6490",
    x1: 53.4658,
    y1: -1.34432,
    x2: 53.4659,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_75_6490",
    x1: 89.4658,
    y1: -1.34432,
    x2: 89.4659,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_75_6490",
    x1: 125.466,
    y1: -1.34432,
    x2: 125.466,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_75_6490",
    x1: 161.466,
    y1: -1.34432,
    x2: 161.466,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_75_6490",
    x1: 196.466,
    y1: -1.34432,
    x2: 196.466,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_75_6490",
    x1: 232.466,
    y1: -1.34432,
    x2: 232.466,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_75_6490",
    x1: 0,
    y1: 19.454,
    x2: 255.154,
    y2: 19.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_75_6490",
    x1: 0,
    y1: 78.454,
    x2: 255.154,
    y2: 78.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_75_6490",
    x1: 0,
    y1: 48.454,
    x2: 255.154,
    y2: 48.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_75_6490",
    x1: 60,
    y1: 16.625,
    x2: 60,
    y2: 104.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_75_6490",
    x1: 60,
    y1: 16.625,
    x2: 60,
    y2: 104.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_6490"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.625,
    width: 250,
    height: 250,
    rx: 10,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigcontact3);
export default __webpack_public_path__ + "static/media/bigcontact3.a69d25848257d9fbb4833fa74f7e49b0.svg";
export { ForwardRef as ReactComponent };